(function() {
  class $ba2f824fee2fc6ee$var$RecentlyViewed extends HTMLElement {
    constructor() {
      super();
      window.Shopify = window.Shopify || {};
      window.Shopify.recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
      this.container = this.querySelector("[data-slider]");
    }
    connectedCallback() {
      if (!this.container || !window.Shopify.recentlyViewed) return;
      if (window.Shopify.recentlyViewed.length > 0) this.loadProducts(); else this.emitState();
    }
    async loadProducts() {
      const loadPromises = window.Shopify.recentlyViewed.map(handle => {
        const trimmedHandle = handle.trim();
        return this.loadProduct(trimmedHandle.split("#")[0]);
      });
      await Promise.allSettled(loadPromises);
      if (this.container.querySelector("[data-slide]")) this.show();
      this.emitState();
    }
    show() {
      this.classList.remove("hidden");
    }
    removeItem(handle) {
      window.Shopify.recentlyViewed = window.Shopify.recentlyViewed.filter(h => h !== handle);
      localStorage.setItem("recentlyViewed", JSON.stringify(window.Shopify.recentlyViewed));
    }
    loadProduct(handle) {
      const url = location.href.match(`/products/([^?]+)`);
      const currentHandle = url ? url[1] : null;
      if (currentHandle && handle === currentHandle) return Promise.resolve();
      return fetch(`${window.Shopify?.routes?.root || "/"}products/${handle}?view=card-product`).then(response => {
        if (!response.ok) {
          this.removeItem(handle);
          throw Error(response.statusText);
        }
        return response.text();
      }).then(text => {
        const html = (new DOMParser).parseFromString(text, "text/html");
        const productCard = html.body.firstElementChild;
        if (productCard) {
          const item = document.createElement("div");
          item.classList.add("slide", "w-grid", "shrink-0", "snap-start", "[--columns:4]", "tablet:[--columns:calc(4/3)]");
          item.setAttribute("data-slide", "true");
          item.innerHTML = productCard.outerHTML;
          this.container.appendChild(item);
        } else {
          this.removeItem(handle);
          throw Error("No product card found");
        }
      }).catch(error => {
        console.warn("RecentlyViewed: Could not load product: " + handle + ". " + error);
      });
    }
    emitState() {
      const hasContent = !!this.container?.querySelector("[data-slide]");
      this.dispatchEvent(new CustomEvent("recently-viewed:state", {
        detail: {
          hasContent: hasContent
        },
        bubbles: true
      }));
    }
  }
  if (!customElements.get("recently-viewed")) customElements.define("recently-viewed", $ba2f824fee2fc6ee$var$RecentlyViewed);
})();